export default __webpack_public_path__ + "static/media/phone-icon.820eb8d7.svg";